/**
 * Focuses the map search box once md-autocomplete has rendered it. The input's
 * own id is generated by Angular Material, so it is looked up through the
 * search container instead. Returns whether an input was found.
 */
export function focusMapSearchInput(root: ParentNode = document): boolean {
    const input = root.querySelector<HTMLInputElement>(
        "#search-container input"
    );
    if (!input) {
        return false;
    }
    input.focus();
    return true;
}
